import { Component } from "react";
import { connect } from "react-redux";
import { getUA, isMobile } from "react-device-detect";
import { Col, Container, Form, Button, Spinner } from "react-bootstrap";
import { withRouter } from "next/router";
import { hotjar } from "react-hotjar";

import xVerifyEmailService from "../../../../services/xVerifyEmailService";
import { checkEmail } from "../../../../helpers/emailChecker";
import { checkDate } from "../../../../helpers/dateChecker";

import * as actionCreater from "../../../../store/actions/productActions";

import _withFormWrapper from "../../../../component/FormWrapper";
import Dates from "../../../../component/date/Dates";
import GeneralQuestions from "../../../../component/form/GeneralQuestions";
import Communication from "../../../../component/form/Communication";
import ActivityInputs from "../../../../component/form/ActivityInputs";
import CorporateAddress from "../../../../component/form/CorporateAddress";
import StepProgress from "../../../../component/StepProgress";
import LegalInformation from "../../../../component/EINChurch/LegalInformation";
import ResponsiblePartyInformation from "../../../../component/form/ResponsiblePartyInformation";
import Error from "../../../../component/form/Error";

import { setItemLocalStorage } from "../../../../variables/Variables";
import ClientAgreement from "../../../form/ClientAgreement";

class EINChurch extends Component {
  state = {
    step: isMobile ? 1 : 7,
    organizedState: "",
    legalName: "",
    dbaname: "",
    responsiblePartyFirstName: "",
    responsiblePartyMiddleName: "",
    responsiblePartyLastName: "",
    responsiblePartySSN: "",
    responsiblePartySuffixName: "",
    responsiblePartyTitle: "",
    activityReasonForApplying: "",
    activityPrimaryActivity: "",
    activitySpecificProducts: "",
    productExtraQuestion1: "",
    productExtraQuestion2: "",
    productExtraQuestion3: "",
    productExtraQuestion4: "",
    productDescription: "",
    questionsAppliedBefore: "false",
    questionsHire: "false",
    questionsExcise: "false",
    questionsATF: "false",
    questionsGambling: "false",
    questionsHighway: "false",
    payLessThan4k: "false",
    annualTaxes: "false",
    previousEINNumberFirst2: "",
    previousEINNumberLast7: "",
    numberOfAgricultureEmployees: "0",
    numberOfHouseholdeEmployees: "0",
    numberOfOtherEmployees: "0",
    firstDateWagesMonth: new Date().getMonth() + 1,
    firstDateWagesDay: new Date().getDate(),
    firstDateWagesYear: new Date().getFullYear(),
    firstDateWagesIsValid: true,
    corpAddressAddress1: "",
    corpAddressAddress2: "",
    corpAddressCity: "",
    corpAddressState: "",
    corpAddressCountry: "US",
    corpAddressZip: "",
    corpAddressCounty: "",
    altAddress: "false",
    altAddressAddress1: "",
    altAddressAddress2: "",
    altAddressCity: "",
    altAddressState: "",
    altAddressCountry: "US",
    altAddressZip: "",
    altAddressCounty: "",
    customerPhone: "",
    customerEmail: "",
    closingMonth: "12",
    startDateYear: new Date().getFullYear(),
    startDateDay: new Date().getDate(),
    startDateMonth: new Date().getMonth() + 1,
    code: "EIN_Church",
    loading: false,
    validated: false,
    verifying: false,
    verificationResult: null,
    suspendedSubmit: false,
  };

  nextStep = () => {
    window.scrollTo(0, 0);
    document.querySelector("#EINForm").classList.remove("was-validated");

    this.setState(({ step }) => ({ step: step + 1, validated: false }));
  };

  backStep = () => {
    window.scrollTo(0, 0);
    document.querySelector("#EINForm").classList.remove("was-validated");

    this.setState(({ step }) => ({ step: step - 1, validated: false }));
  };

  // handleChange = ({ target: { id, name, value } }, newValues = {}) =>
  //   this.setState(
  //     ({ questionsHire, ...state }) => {
  //       if (id.toString().indexOf("Date") !== -1 && questionsHire === "true")
  //         return { [name || id]: value, firstDateWagesIsValid: checkDate({ id, value }, state), ...newValues };
  //       else return { [name || id]: value, ...newValues };
  //     },
  //     () => {
  //       setItemLocalStorage("product", this.state);
  //       localStorage.setItem("path", "EINChurch");
  //     }
  //   );

  
  handleChange = ({ target: { type, id, name, value } }, newValues = {}) => {
    this.setState(
      ({ questionsHire, ...state }) => {
        if (id.toString().indexOf("Date") !== -1 && questionsHire === "true") {
          return { [name || id]: value, firstDateWagesIsValid: checkDate({ id, value }, state), ...newValues };
        } else {
          if (type === "email") {
            return { [name || id]: value, verificationResult: null, ...newValues };
          } else {
            return { [name || id]: value, ...newValues };
          }
        }
      },
      () => {
        setItemLocalStorage("product", this.state);
        localStorage.setItem("path", "EINChurch");
      }
    );
  }

  handleBlur = (e) => {
    const { type, value } = e.target;
    if (type === "email" && value) {
      if (!this.state.verificationResult && checkEmail(value)) {
        this.setState({ verifying: true });

        let emailValue = value;
        if (emailValue.indexOf("+") > -1 && emailValue.indexOf("gmail.com") > -1) {
          emailValue =
            emailValue.substring(0, emailValue.indexOf("+")) +
            emailValue.substring(emailValue.indexOf("@"), emailValue.length);
        }
        xVerifyEmailService(emailValue)
          .then(result => {
            this.setState({
              verificationResult: result,
              verifying: false,
            });
          });
      }
    }
  }

  handleKeyDown = (e) => {
    const { type, value } = e.target;
    if (type === "email" && value && e.code === "Enter") {
      if (!this.state.verificationResult && checkEmail(value)) {
        this.setState({ verifying: true, suspendedSubmit: true });

        let emailValue = value;
        if (emailValue.indexOf("+") > -1 && emailValue.indexOf("gmail.com") > -1) {
          emailValue =
            emailValue.substring(0, emailValue.indexOf("+")) +
            emailValue.substring(emailValue.indexOf("@"), emailValue.length);
        }
        xVerifyEmailService(emailValue)
          .then(result => {
            this.setState({
              verificationResult: result,
              verifying: false,
            });
          });
      }
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();

    if (this.state.verifying) {
      return;
    }

    this.setState({ suspendedSubmit: false });

    const form = e.currentTarget;
    const product = this.props.products.products.filter((u) =>
      u.code.replace("_", "").includes(this.props.router.pathname.substring(10))
    )[0];
    const productDescription = document.querySelector("#productDescription");
    if(productDescription) {
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.productDescription=productDescription.value;
    }
    const productInfo = {
      ...this.state,
      customerName: product.customerName,
      code: product.code,
      device: isMobile && !getUA.includes("Intel") ? "MOBILE" : "DESKTOP",
    };
    localStorage.setItem("product", JSON.stringify(productInfo));
    localStorage.setItem("path", "EINChurch");

    this.props.logOrder(productInfo);
    this.setState({ validated: true });
    const section1 = document.querySelector(".is-invalid");
    if (section1 != null) {
      section1.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector("#EINForm").classList.add("was-validated");
        const section = document.querySelector(".form-control:invalid");
        if(section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } else {
        e.preventDefault();
        if (this.state.step === 7) {
          if (this.state.questionsHire === "false" || this.state.firstDateWagesIsValid) {
            hotjar.event("lead_form_submitted");
            this.setState({ loading: true });
            this.props.orderEINChurchStandardProduct(productInfo, this.props.router);
          }
        } else {
          this.nextStep();
        }
      }
    }
  };

  renderSwitch() {
    switch (this.state.step) {
      case 1:
        return (
          <>
            <LegalInformation state={this.state} onChange={this.handleChange} />
            <Button className="back-btn" hidden onClick={this.backStep}>
              Back
            </Button>
            <Button type="submit">Next</Button>
          </>
        );
      case 2:
        return (
          <>
            <ResponsiblePartyInformation state={this.state} onChange={this.handleChange} />
            <Button className="back-btn" onClick={this.backStep}>
              Back
            </Button>
            <Button type="submit">Next</Button>
          </>
        );
      case 3:
        return (
          <>
            <ActivityInputs state={this.state} onChange={this.handleChange} />
            <Button className="back-btn" onClick={this.backStep}>
              Back
            </Button>
            <Button type="submit">Next</Button>
          </>
        );
      case 4:
        return (
          <>
            <GeneralQuestions
              applyBeforeLabel="Has this church ever received or applied for an EIN before?"
              state={this.state}
              onChange={this.handleChange}
            />
            <Button className="back-btn" onClick={this.backStep}>
              Back
            </Button>
            <Button type="submit">Next</Button>
          </>
        );
      case 5:
        return (
          <>
            <CorporateAddress
              id="corpAddress"
              header="Corporate Address (PO Boxes are not authorized)"
              state={this.state}
              onChange={this.handleChange}
            />
            <Button className="back-btn" onClick={this.backStep}>
              Back
            </Button>
            <Button type="submit">Next</Button>
          </>
        );
      case 6:
        return (
          <>
            <Dates
              id="startDate"
              label="Date entity was started or acquired"
              day={this.state.startDateDay}
              month={this.state.startDateMonth}
              year={this.state.startDateYear}
              closingMonth={this.state.closingMonth}
              onChange={this.handleChange}
            />
            <Button className="back-btn" onClick={this.backStep}>
              Back
            </Button>
            <Button type="submit">Next</Button>
          </>
        );
      case 7:
        return (
          <>
            <Communication state={this.state} onChange={this.handleChange} onBlur={this.handleBlur} onKeyDown={this.handleKeyDown} />
            <ClientAgreement />
            <Error error={this.props.error} />
            <Button className="back-btn" onClick={() => this.setState({ step: 5 })}>
              Back
            </Button>
            <Button
              id="EINSubmitButton"
              type="submit"
              disabled={this.state.loading}
              onMouseDown={() => this.handleChange({ target: { id: "suspendedSubmit", value: true } })}
            >
              Submit
            </Button>
          </>
        );
      default:
        return <></>;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.error !== this.props.error && this.props.error) {
      this.setState({ loading: false });
    }
    if (prevState?.verifying && !this.state.verifying && this.state.suspendedSubmit) {
      document.getElementById("EINSubmitButton")?.click();
    }
  }

  componentDidMount() {
    this.props.getProducts();
    this.props.clearError();

    const product = JSON.parse(localStorage.getItem("product"));
    const historyPath = localStorage.getItem("path");

    if (historyPath && historyPath === "EINChurch" && product) {
      window.scrollTo(0, 0);

      this.setState({ ...product, step: isMobile ? 1 : 7, loading: false, suspendedSubmit: false });
    }

    if (product?.customerEmail && checkEmail(product.customerEmail)) {
      this.setState({ verifying: true });

      const domain = process.env.NEXT_PUBLIC_REACT_APP_XVERIFY_API_DOMAIN || window.location.host;

      let emailValue = product.customerEmail;
      if (emailValue.indexOf("+") > -1 && emailValue.indexOf("gmail.com") > -1) {
        emailValue =
          emailValue.substring(0, emailValue.indexOf("+")) +
          emailValue.substring(emailValue.indexOf("@"), emailValue.length);
      }
      xVerifyEmailService(emailValue, domain)
        .then(result => {
          this.setState({
            verificationResult: result,
            verifying: false,
          });
        });
    }
  }

  render() {

    if (this.state.loading) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner animation="border"/>
        </div>
      );
    }
    
    if (this.props.products.products.length === 0) return <Container fluid />;

    return (
      <Container fluid className="Form">
        <StepProgress step={0} />
        <h3>Step 1: 2025 Church Organization Tax ID / SS-4 Form</h3>
        <Col sm={12}>
          {isMobile ? (
            <Form id="EINForm" noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
              {this.renderSwitch()}
            </Form>
          ) : (
            <Form id="EINForm" noValidate validated={this.state.validated} onSubmit={this.handleSubmit}>
              <LegalInformation state={this.state} onChange={this.handleChange} />
              <hr />
              <ResponsiblePartyInformation state={this.state} onChange={this.handleChange} />
              <hr />
              <ActivityInputs state={this.state} onChange={this.handleChange} />
              <hr />
              <GeneralQuestions
                applyBeforeLabel="Has this church ever received or applied for an EIN before?"
                state={this.state}
                onChange={this.handleChange}
              />
              <hr />
              <CorporateAddress
                id="corpAddress"
                header="Corporate Address (PO Boxes are not authorized)"
                state={this.state}
                onChange={this.handleChange}
              />
              <hr />
              <Dates
                id="startDate"
                label="Date entity was started or acquired"
                tooltip
                day={this.state.startDateDay}
                month={this.state.startDateMonth}
                year={this.state.startDateYear}
                closingMonth={this.state.closingMonth}
                onChange={this.handleChange}
              />
              <hr />
              <Communication state={this.state} onChange={this.handleChange} onBlur={this.handleBlur} onKeyDown={this.handleKeyDown} />
              <hr />
              <ClientAgreement />
              <Error error={this.props.error} />
              <Button
                id="EINSubmitButton"
                variant="primary"
                type="submit"
                className="mt-4"
                disabled={this.state.loading}
                onMouseDown={() => this.handleChange({ target: { id: "suspendedSubmit", value: true } })}
              >
                Submit Application
              </Button>
            </Form>
          )}
        </Col>
      </Container>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  orderEINChurchStandardProduct: (productInfo, history) => {
    dispatch(actionCreater.churchEinOrder(productInfo, history));
  },
  getProducts: () => {
    dispatch(actionCreater.getProducts());
  },
  clearError: () => {
    dispatch(actionCreater.clearErrorMessage());
  },
  logOrder: (productInfo) => {
    dispatch(actionCreater.logOrder(productInfo));
  },
});

const mapStateToProps = ({ products }) => ({ products, error: products.error });

export default _withFormWrapper(connect(mapStateToProps, mapDispatchToProps)(withRouter(EINChurch)));
